<template>
<div class="mt-3">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-2 px-3">
        <h2 class="text-white text-sm font-semibold">Total cumulé</h2>
    </div>
    <div class="px-2 py-3">
        <div class="mt-3 space-y-1">
            <div class="flex justify-between text-sm" v-if="loyersTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Loyers</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(loyersTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="chargesTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Charges</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(chargesTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="taxeFonciereTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Taxe foncière</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(taxeFonciereTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="pretsTotal !== 0">
                <span class="text-gray-500 dark:text-gray-400">Prêts</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(pretsTotal) }}</span>
            </div>
            <div class="flex justify-between text-sm" v-if="montantVente !== 0">
                <span class="text-gray-500 dark:text-gray-400">Montant des ventes</span>
                <span class="text-gray-700 dark:text-gray-200">{{ format(montantVente) }}</span>
            </div>
        </div>

        <div class="flex justify-between items-center mt-3 pt-2 border-t border-gray-200 dark:border-gray-800">
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Total net</span>
            <span class="text-lg font-medium" :class="totalNet >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ format(totalNet) }}</span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        loyersTotal: {
            type: Number,
            default: 0
        },
        chargesTotal: {
            type: Number,
            default: 0
        },
        taxeFonciereTotal: {
            type: Number,
            default: 0
        },
        pretsTotal: {
            type: Number,
            default: 0
        },
        montantVente: {
            type: Number,
            default: 0
        },
        totalNet: {
            type: Number,
            default: 0
        }
    },

    methods: {
        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
